let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
import styled, { css } from 'styled-components';
import { colors } from '@ovpn-ui/styles';
import Box from '../../Box';
const xPlacement = ['top', 'bottom'];
const yPlacement = ['left', 'right'];
const oppositePlacement = {
  top: 'bottom',
  bottom: 'top',
  right: 'left',
  left: 'right'
};
const arrowSize = 12;
const makeArrowBorderStyles = (placement, color, size) => {
  const adjacentPlacement = xPlacement.includes(placement) ? yPlacement : xPlacement;
  return css(_t || (_t = _`
        ${0}: ${0}px solid var(--arrow-color, ${0});
        ${0}: ${0}px solid transparent;
        ${0}: ${0}px solid transparent;
    `), `border-${placement}`, size, color, `border-${adjacentPlacement[0]}`, size, `border-${adjacentPlacement[1]}`, size);
};
function makeArrowStyles(placement) {
  const borderSize = arrowSize / 2;
  const afterBorderSize = arrowSize * 3 / 8;
  const afterPlacement = xPlacement.includes(placement) ? 'left' : 'top';
  return css(_t2 || (_t2 = _`
        &[data-placement*='${0}'] {
            ${0}: -${0}px;
            ${0}: 0px;

            ${0}

            &:after {
                ${0}: -${0}px;
                ${0}: -${0}px;

                ${0}
            }
        }
    `), placement, oppositePlacement[placement], arrowSize, afterPlacement, makeArrowBorderStyles(placement, colors.darkSlateBlue, borderSize), placement, borderSize, afterPlacement, afterBorderSize, makeArrowBorderStyles(placement, colors.white, afterBorderSize));
}
export const Arrow = styled.div(_t3 || (_t3 = _`
    position: absolute;

    width: ${0}px;
    height: ${0}px;

    &:after {
        position: absolute;

        width: 0;
        height: 0;

        content: '';
    }

    ${0}
    ${0}
    ${0}
    ${0}
`), arrowSize, arrowSize, makeArrowStyles('top'), makeArrowStyles('bottom'), makeArrowStyles('right'), makeArrowStyles('left'));
export const StyledPopper = styled(Box)(_t4 || (_t4 = _`
    background: ${0};

    border-radius: 3px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.08);
`), colors.white);